import store from '@/store';
import i18n from '@/i18n';
import http from './http';

/**
 * Opens a print popup window with the given HTML content.
 */
function openPrintPopup(htmlContent, title = '') {
  const width = 780;
  const height = 500;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  setTimeout(() => {
    const win = window.open(
      'about:blank',
      title,
      `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`,
    );

    if (win) {
      win.document.body.innerHTML = htmlContent;
      win.focus();
      win.print();
    } else {
      // eslint-disable-next-line no-alert
      window.alert(i18n.t('errors.popupBlocked'));
    }
  }, 10);
}

export default {
  async printReceipt(paymentId) {
    const response = await http.get(`${store.state.settings.apiURL}/Payments/PrintReceipt`, {
      params: { PaymentId: paymentId },
    });
    openPrintPopup(response.data, 'Receipt');
  },

  async getSaleOrderReceipt(saleOrderId) {
    const response = await http.post(`${store.state.settings.apiURL}/SaleOrder/${saleOrderId}/Receipt`);
    openPrintPopup(response.data);
  },

  async printMembershipEnrollment(membershipId) {
    const response = await http.get(
      `${store.state.settings.apiURL}/Memberships/PrintMembershipEnrollment`,
      { params: { MembershipId: membershipId } },
    );
    openPrintPopup(response.data, 'Membership Enrollment');
  },
};
